module.exports = ['$scope', 'MyPlaylistShare', 'StatusHelper', function EditMyPlaylistSharesCtrl($scope, MyPlaylistShare, StatusHelper) {
    "use strict";

    $scope.isLoading = true;

    $scope.shares = MyPlaylistShare.query({
        playlistId: $scope.playlist.id
    }, function (resp) {
        $scope.isLoading = false;
    }, function () {
        $scope.isLoading = false;
    });

    $scope.statusHelper = new StatusHelper();

    $scope.deleteShare = function (share) {
        $scope.statusHelper.set(share, 'loading');
        share.$delete(function () {
            $scope.statusHelper.unset(share, 'loading');
            $scope.shares.splice($scope.shares.indexOf(share), 1);
        }, function () {
            $scope.statusHelper.unset(share, 'loading');
            $scope.statusHelper.set(share, 'error');
        });
    };

    $scope.updateShare = function (share) {
        $scope.statusHelper.set(share, 'loading');
        share.$save(function () {
            $scope.statusHelper.unset(share, 'loading');
        }, function () {
            $scope.statusHelper.unset(share, 'loading');
            $scope.statusHelper.set(share, 'error');
        });
    };
}];


// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistclientbundle/Resources/js/angular/controllers/EditMyPlaylistSharesCtrl.js